'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const FiiDiiChartInner = dynamic(() => import('./FiiDiiChartInner'), { ssr: false });

export default function FiiDiiChartSection() {
  return (
    <div className="card-surface p-5">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-base font-semibold">FII / DII Net Flow</h2>
          <p className="text-xs mt-0.5" style={{ color: 'var(--muted-foreground)' }}>
            Last 10 trading sessions · ₹ Crores
          </p>
        </div>
        <div className="flex items-center gap-4 text-xs">
          <div className="flex items-center gap-1.5">
            <div className="w-2.5 h-2.5 rounded-sm" style={{ background: 'var(--primary)' }} />
            <span style={{ color: 'var(--muted-foreground)' }}>FII</span>
          </div>
          <div className="flex items-center gap-1.5">
            <div className="w-2.5 h-2.5 rounded-sm" style={{ background: 'var(--accent)' }} />
            <span style={{ color: 'var(--muted-foreground)' }}>DII</span>
          </div>
        </div>
      </div>
      <FiiDiiChartInner />
    </div>
  );
}